// Formato de hora para mostrar en pantalla.
// La aplicación trabaja internamente en 24 h ("HH:MM", que es lo que espera la
// base de datos); estas funciones son SOLO para visualización.

/**
 * Convierte "HH:MM" (o "HH:MM:SS", o un Date) a 12 horas: "2:30 p.m."
 * Si el valor no se reconoce, se devuelve tal cual para no romper la vista.
 */
export function to12h(value) {
  if (value === null || value === undefined || value === '') return '';

  let h, m;
  if (value instanceof Date) {
    h = value.getHours();
    m = value.getMinutes();
  } else {
    const match = String(value).match(/(\d{1,2}):(\d{2})/);
    if (!match) return String(value);
    h = Number(match[1]);
    m = Number(match[2]);
  }
  if (isNaN(h) || isNaN(m)) return String(value);

  const sufijo = h >= 12 ? 'p.m.' : 'a.m.';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, '0')} ${sufijo}`;
}

/** Rango de horas en 12 h: "2:30 p.m. - 3:00 p.m." */
export function rango12h(inicio, fin) {
  const a = to12h(inicio);
  const b = to12h(fin);
  if (!a) return '';
  return b ? `${a} - ${b}` : a;
}
